import { routes as account } from './account/routes';
import { routes as activationCodes } from './activation-codes/routes';
import { routes as admins } from './admins/routes';
import { routes as audit } from './audit/routes';
import { routes as dashboard } from './dashboard/routes';
import { routes as health } from './health/routes';
import { routes as plans } from './plans/routes';
import { routes as settings } from './settings/routes';
import { routes as supportChat } from './support-chat/routes';
import { routes as support } from './support/routes';
import { routes as tenants } from './tenants/routes';
import { routes as plugins } from './plugins/routes';
import { routes as whatsapp } from './whatsapp/routes';
import type { FeatureRoute } from './types';

/**
 * Every feature's routes. Each Phase 3 agent owns its folders' `routes.tsx` (A1: dashboard, account;
 * A2: tenants, activation-codes; A3: plans, support, audit, health, admins) — this file never needs
 * editing to add a screen.
 */
export const featureRoutes: FeatureRoute[] = [
  ...dashboard,
  ...account,
  ...tenants,
  ...activationCodes,
  ...plans,
  ...supportChat,
  ...support,
  ...audit,
  ...health,
  ...admins,
  ...settings,
  ...whatsapp,
  ...plugins,
];

const registered = new Set(featureRoutes.map((r) => `/${r.path.replace(/^\/+/, '')}`));

/** True when a screen exists for this nav path (otherwise the nav shows it as "SOON"). */
export function hasScreen(path: string): boolean {
  return registered.has(path);
}
